export default {
    'fallbackLocale': 'es-MX',
    'locale': 'es-MX',
    'messages': {
        'es-MX': {
            'loading': 'Por favor espere, obteniendo información ...',
            'close-action': 'Cerrar',
            'ok-action': 'Aceptar',
            'idioma': 'INGLES',
            'room map': 'Mapa de Salas',
            'picture Rooms': 'Imagines de Salas',
            'attributes': 'Atributos',
            'section rules': 'Reglas de apartado',
            'meetingRooms': 'Salas de Juntas',
        },
        'en': {
            'loading': 'Please stand by, loading info ...',
            'close-action': 'Close',
            'ok-action': 'Ok',
            'idioma': 'SPANISH',
            'room map': 'Room Map',
            'picture Rooms': 'Picture Rooms',
            'attributes': 'Attributes',
            'section rules': 'section rules',
            'meetingRooms': 'Meeting Rooms'
        }
    }
}